import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {AuthService} from "../../../../shared/services/auth.service";
import {RiskDictionary} from "../../../../shared/interface/risk-dictionary";

@Component({
  selector: 'app-risk-dict-group-view',
  templateUrl: './risk-dict-group-view.component.html',
  styleUrls: ['./risk-dict-group-view.component.scss']
})
export class RiskDictGroupViewComponent implements OnInit {
  @Input() riskDictionary: RiskDictionary;
  @Output() modifyClicked = new EventEmitter<any>();

  userPermissions: ReplaySubject<UserPermissions>;

  constructor(
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
  }

  modify(): void {
    this.modifyClicked.emit();
  }

}
